<template>
    <div class="article">
        <nuxt-link
            v-if="!isExternalLink"
            class="article_link box_shadow"
            :to="internalLink"
        >
            <div class="title">
                <h3>
                    {{ name }}
                </h3>
            </div>
        </nuxt-link>
        <a
            v-else
            v-bind="additionalAttributes"
            :href="externalLink"
            class="article_link box_shadow"
        >
            <h3>{{ name }}</h3>
        </a>
    </div>
</template>
<script>
import SimilarItemBase from './SimilarItemBase';

export default {
    extends: SimilarItemBase
};
</script>
